import { useContext } from "react";
import { ReactReduxContext } from "react-redux";
import { projectsActions } from "../../backend/store/reducers/projectsReducer";
import { getUser } from "../../backend/store/actions/creators/getUser";

/** Ask today's auth store to reload the signed-in person and account (the old pages and the old menu read them); nothing without a store. */
export const useRefreshLegacyUser = (): (() => void) => {
  const store = useContext(ReactReduxContext)?.store;
  return () => { store?.dispatch(getUser()); };
};

/** Ask today's projects store (the old project chip, Projects page and Map) to reload after a project write. */
export const useRefreshLegacyProjects = (): (() => void) => {
  const store = useContext(ReactReduxContext)?.store;
  return () => { store?.dispatch(projectsActions.fetchProjects()); };
};
